import { axiosInstance } from "./axios";
import { IRecoveryPackageResponse } from "utils/decryptKeys";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";

const queryKeys = {
  getRecoveryPackage: "keysService.getRecoveryPackage",
};

const getRecoveryPackage = async (): Promise<IRecoveryPackageResponse> => {
  const response = await axiosInstance.get(`/account/recoveryPackage`);
  return response.data ?? [];
};

const useGetRecoveryPackage = (enabled: boolean = true) => {
  return useCustomQuery(
    queryKeys.getRecoveryPackage,
    () => getRecoveryPackage(),
    {
      staleTime: 0,
      cacheTime: 0,
      retry: false,
      enabled: enabled,
    },
  );
};

export interface ICreateRecoveryPackage {
  username: string;
  publicKey: string;
  recovery: string;

  intermediatePrivateKey?: string;
  intermediatePublicKey?: string;
}

export interface IKeysCreateObject {
  CaseId: string | null;
  PrivateKey: string;
  PublicKey: string;
}

export interface IKeysCreateObjectResponse {
  Id: string;
  ParentKeyId: string;
}

const createObject = (
  payload: IKeysCreateObject,
): Promise<{ data: IKeysCreateObjectResponse }> => {
  return axiosInstance.post("/keys/object", payload);
};

const useCreateObject = () => {
  return useCustomMutation(createObject);
};

const createRecoveryPackage = (
  payload: ICreateRecoveryPackage,
): Promise<void> => {
  return axiosInstance.post("/account/recoveryPackage", payload);
};

const useCreateRecoveryPackage = () => {
  return useCustomMutation(createRecoveryPackage);
};

export default {
  useGetRecoveryPackage,
  useCreateObject,
  useCreateRecoveryPackage,
};
